
import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Card, Button, Tooltip, OverlayTrigger } from '@themesberg/react-bootstrap';
import Highlight, { Prism } from 'prism-react-renderer';

import themeStyle from "../assets/syntax-themes/ghcolors.json";

export default (props) => {
  const { code = "", language = "jsx" } = props;
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const CodeStyling = ({ className, style, tokens, getLineProps, getTokenProps }) => (
    <Card className="mb-2 code-sample overflow-hidden">
      {/* Toolbar above the code so Copy never overlays the sample on mobile. */}
      <div className="d-flex align-items-center justify-content-end px-3 py-2 border-bottom code-sample-toolbar">
        {copied ? <span className="text-success small me-2">Copied</span> : null}
        <OverlayTrigger
          trigger={['hover', 'focus']}
          placement="top"
          overlay={<Tooltip>Copy to clipboard</Tooltip>}
        >
          <CopyToClipboard text={code} onCopy={handleCopy}>
            <Button size="sm" variant="outline-primary">Copy</Button>
          </CopyToClipboard>
        </OverlayTrigger>
      </div>
      <Card.Body className="p-3 overflow-auto">
        <pre
          className={className}
          style={{
            ...style,
            margin: 0,
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
          }}
        >
          {tokens.map((line, i) => (
            <div {...getLineProps({ line, key: i })}>
              {line.map((token, key) => <span {...getTokenProps({ token, key })} />)}
            </div>
          ))}
        </pre>
      </Card.Body>
    </Card>
  );

  return (
    <Highlight Prism={Prism} code={code} language={language} theme={themeStyle}>
      {CodeStyling}
    </Highlight>
  );
};
